import { useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { FiCheckCircle, FiClock } from 'react-icons/fi';
import { CSSTransition } from 'react-transition-group';
import multiDevice from './img/multi-device.gif';
import { useTranslation } from 'react-i18next';
import {
  ModalSuccess,
  ModalSuccessBody,
  ModalSuccessContainer,
  ModalSuccessContent,
  ModalSuccessHeader,
  ModalSuccessImg,
  ModalSuccessKpi,
  ModalSuccessKpiIcon,
  ModalSuccessKpiInner,
  ModalSuccessKpiLabel,
  ModalSuccessKpiValue,
  ModalSuccessKpiWrapper,
  ModalSuccessName,
  ModalSuccessText,
  ModalSuccessTitle
} from '@/components/custom/modal';
import { Button } from '@/components/ui/button';

export function ExamsQuestionsModalSubmitted(props) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { show, questionBook, questions, countAnswered, elapsedTimeInMinutes, formattedDate } = props;

  useEffect(() => {
    if (show) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'visible';
  }, [show]);

  const nodeRef = React.useRef(null);

  return ReactDOM.createPortal(
    <CSSTransition
      in={show}
      unmountOnExit
      nodeRef={nodeRef}
      timeout={{ enter: 0, exit: 300 }}
    >
      <ModalSuccess
        isActive={show}
        ref={nodeRef}
      >
        <ModalSuccessContent onClick={event => event.stopPropagation()}>
          <ModalSuccessImg
            src={multiDevice}
            alt=""
          />

          <ModalSuccessContainer>
            <ModalSuccessHeader>
              <ModalSuccessTitle>{t('exams.titleSendAnswers')}</ModalSuccessTitle>
            </ModalSuccessHeader>

            <ModalSuccessBody>
              <ModalSuccessText>{t('exams.textCongratulations')}</ModalSuccessText>
              <ModalSuccessName>{questionBook?.title}</ModalSuccessName>
              {questionBook?.['learning-system-ids']?.length > 0 ? (
                <ModalSuccessText>{t('exams.textResultPerformace')}</ModalSuccessText>
              ) : (
                <ModalSuccessText>
                  {t('exams.textAbleToPerformace')} <strong>{formattedDate}</strong>
                </ModalSuccessText>
              )}
            </ModalSuccessBody>

            <ModalSuccessKpiWrapper className="mb-4">
              <ModalSuccessKpi>
                <ModalSuccessKpiIcon>
                  <FiClock />
                </ModalSuccessKpiIcon>
                <ModalSuccessKpiInner>
                  <ModalSuccessKpiValue>{elapsedTimeInMinutes}</ModalSuccessKpiValue>
                  <ModalSuccessKpiLabel>{t('exams.examMinutes')}</ModalSuccessKpiLabel>
                </ModalSuccessKpiInner>
              </ModalSuccessKpi>
              <ModalSuccessKpi>
                <ModalSuccessKpiIcon>
                  <FiCheckCircle />
                </ModalSuccessKpiIcon>
                <ModalSuccessKpiInner>
                  <ModalSuccessKpiValue>
                    {countAnswered()}/{questions.length}
                  </ModalSuccessKpiValue>
                  <ModalSuccessKpiLabel>{t('exams.answeredQuestions')}</ModalSuccessKpiLabel>
                </ModalSuccessKpiInner>
              </ModalSuccessKpi>
            </ModalSuccessKpiWrapper>

            <Button
              wide
              onClick={() => navigate('/avaliacoes/meus-resultados')}
            >
              {questionBook?.['learning-system-ids']?.length > 0 ? t('exams.thResults') : t('exams.closeExam')}
            </Button>
          </ModalSuccessContainer>
        </ModalSuccessContent>
      </ModalSuccess>
    </CSSTransition>,
    document.getElementById('modal_root')
  );
}
